<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-maketing-register"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="{'farmer': theme == 'farmer', 'subdist': theme == 'subdist', 'dist': theme == 'dist', 'sale': theme == 'sale'}">
                <div class="modal-base-head">
                    <div id="Marketing_header" class="modal-head-txt theme-txt" v-html="title"></div>
                </div>
                <div class="modal-base-body" >
                    <div ref="marketingRegisterModal" class="marketing-content" v-html="marketingContent"></div>
                    <div v-if="!bottomOfContent" @click="scrollToElement()" class="tab-to-bottom">
                        <div class="text-tab">
                            {{ lbl.register.tab_to_bottom }}
                        </div>
                        <img src="@/assets/icon/ic-double-down-new-green.svg" alt="">
                    </div>
                    <div class="content-area">
                        <div class="text-title" v-html="lbl.register.marketing.msg"></div>
                        <div class="checkbox-content">
                            <div class="cb-box">
                                <InputCheckBox v-model="isAll"
                                                :textLbl="lbl.marketing.all"
                                                :all="true"
                                                @onClickAll="onClickAll($event)" />
                                <InputCheckBox  v-model="isSMS"
                                                :textLbl="lbl.marketing.sms"
                                                :sms="true"
                                                @onAcceptSMS="onAcceptSMS($event)" />
                            </div>
                            <div class="cb-box">
                                <InputCheckBox  v-model="isEmail"
                                                :textLbl="lbl.marketing.email"
                                                :email="true"
                                                @onAcceptEmail="onAcceptEmail($event)" />
                                <InputCheckBox  v-model="isLine"
                                                :textLbl="lbl.marketing.line"
                                                :line="true"
                                                @onAcceptLine="onAcceptLine($event)" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div id="close_Marketing_modal">
                        <div class="btn-wrapper btn-cancel" @click="clickClose()">
                            <div class="btn-txt">
                                {{lbl.register.btn_close}}
                            </div>
                        </div>
                    </div>
                    <div id="accept_Marketing_modal">
                        <div class="btn-wrapper"
                             @click="clickAccept()" v-if="toggle && bottomOfContent || isAcceptMarketing">
                            <div class="btn-txt">
                                {{btnAcceptMarketing}}
                            </div>
                        </div>
                        <div class="btn-wrapper btn-disable" v-else>
                            <div class="btn-txt">
                                {{btnAcceptMarketing}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
//hepler
import Locale from '@/helper/locale/locale.js';
import Util from "@/helper/Utility.js";
//service
import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";
//model
// import { PDPAModel } from '@/core/PDPA/model/PDPAModel.js';
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//component
import InputCheckBox from "@/components/Input/InputCheckBox.vue";
export default {
    name: "MarketingRegisterModal",
    mixins: [AccountMixin],
    components: {
        InputCheckBox
    },
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function () {
        return {
            title: '',
            tag: '',
            btnAcceptMarketing: '',
            busModal: null,
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),

            busPDPA: new Vue(),
            bottomOfContent: false,

            isAll: true,
            isEmail: true,
            isSMS: true,
            isLine: true,
            isNotification: true,
            toggle: true,
            MarketingVersion: null,
            privacyVersion: null,
            marketingVersion: null,
            marketingContent: null,
            // token: this.getToken(),
            consent: {},
            isAcceptMarketing: false
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //event
        clickAccept: function () {
            this.hide();
            var marketing = {
                email: this.isEmail,
                sms: this.isSMS,
                line: this.isLine,
                notification: this.isNotification,
            }
            this.controller.sendCallbackAcceptMarketing({ accept: true, marketing:  marketing});
        },
        clickClose: function () {
            this.hide();
            this.controller.confirmModal
                .clearText()
                .setTag('marketing-confirm')
                .setTitle(this.lbl.register.marketing.close_modal.title)
                .setMsg(this.lbl.register.marketing.close_modal.msg)
                .setBtnOk(this.lbl.register.marketing.close_modal.btn_setting)
                .setBtnCancel(this.lbl.register.marketing.close_modal.btn_not_recive)
                .show()

            this.controller.confirmModal
                .onClickCancel(() => {
                    this.controller.sendCallbackCancelMarketing(true);
                });
            this.controller.confirmModal
                .onClickOk(() => {
                    this.controller.sendCallbackConfirmMarketing(true);
                });
        },
        initialPDPA: function () {
            this.getPDPAVesion()
                .then((versionResult) => {
                    var version = versionResult.data.marketing.current_version;
                    console.log(version);
                    
                    return this.getPDPAContent(version);
                })
                .catch((error) => {
                    console.log(error);
                    // this.errorResponse(error, this.errorHandler);
                });
        },
        getPDPAVesion: function () {
            return PDPAService.apiGetPDPAVersion();
        },
        getPDPAContent: function (version) {
            PDPAService.apiGetPDPAContent("marketing", version, this.lblCode).then((res) => {
                this.marketingContent = res.data;
            })
            .catch((error) => {
                console.log(error);
                // this.errorResponse(error, this.errorHandler);
            });
        },
        onAcceptEmail: function (data) {
            this.isEmail = data;
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
            this.checkBtnAccept();
        },
        onAcceptSMS: function (data) {
            this.isSMS = data;
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
            this.checkBtnAccept();
        },
        onAcceptLine: function (data) {
            this.isLine = data;
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
            this.checkBtnAccept();
        },
        onClickAll: function (all) {
            if (all) {
                this.isEmail = true;
                this.isSMS = true;
                this.isLine = true;
                this.toggle = true;
            } else {
                this.isEmail = false,
                this.isSMS = false,
                this.isLine = false,
                this.toggle = false;
            }
        },
        checkBtnAccept: function() {
            if (this.isAll || this.isEmail ||
                this.isSMS || this.isLine) {
                this.toggle = true;
            } else {
                this.toggle = false;
            }
        },
        //control
        show: function(config) {
            this.title = config.title;
            this.btnAcceptMarketing = config.btnAcceptMarketing;
            this.tag = config.tag;
            this.bottomOfContent = false;
            this.isAcceptMarketing = config.isAcceptMarketing;
            if (Util.isEmptyStr(config.btnAcceptMarketing)) {
                this.btnAcceptMarketing = this.lbl.default.ok;
            }
            this.initialPDPA();
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        scrollToElement: function () {
            const el = this.$refs.marketingRegisterModal;
            const heightScroll  = el.scrollHeight
            el.scrollTo({
                top: heightScroll,
                behavior: "smooth",
            });
            this.bottomOfContent = true;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
.modal-base-head {
    #Marketing_header {
        padding-bottom: 20px;
    }
}
.modal-base-body {
    position: relative;
    .marketing-content {
        width: 100%;
        height: 50vh;
        padding: 20px 8px;
        border: solid 1px $a-gray-C4C4C4;
        border-radius: 8px;
        overflow-y: scroll;
        overflow-x: hidden;

        @media (max-width: $max-width-mini-mobile) {
            margin-bottom: 20px;
        }
        &::-webkit-scrollbar {
            width: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: $orange1;
            border-radius: 5px;
        }
    }
    .tab-to-bottom {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 11rem;
        background-color: $a-green-E6F5F2;
        padding : 0px 10px;
        @extend %display-flex;
        justify-content: center;
        width: 95%;
        margin: auto;
        .text-tab {
            font-size: 1.25rem;
            color: $green-00987F;
            margin-right: 4px;
        }
    }
    .content-area {
        margin-top: 5px;
        .text-title {
            text-align: center;
        }

        .checkbox-content {
            // @extend %display-flex-nowrap;
            display: flex;
            width: 100%;
            padding: 0 30px;
            .cb-box {
                flex: 0 0 65%;
                width: 65%;
            }
        }
    }
}
    .modal-base-footer {
        @extend %display-flex;
        width: 100%;
        // flex : 0 0 calc(100% / 2);
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        #close_Marketing_modal {
            width: 35%;
        }
        #accept_Marketing_modal {
            width: 60%
        }
    }
</style>
<style lang="scss">
@import "@/style/modal.scss";
    .modal-maketing-register {
        @extend %modal-base;

        .modal-dialog {
            height: 90vh;
            max-height: 90vh;
            min-height: 100%;
        }
    }
</style>
